import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 0 1rem;

  .timeline-item {
    &::before {
      flex: 0;
    }
  }
  .timeline-dot {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .step-icon {
    position: absolute;
  }
  .result-description{
     color: ${props => `${props.theme.palette.success.main}`};
  }

  .result-list-item {
    align-items: flex-start;
  }
  .success-result {
    > p {
      color: ${props => `${props.theme.palette.success.main}`};
    }
  }
  .error-result {
    > p {
      color: ${props => `${props.theme.palette.error.main}`};
    }
  }
  .warning-result {
    > p {
      color: ${props => `${props.theme.palette.warning.main}`};
    }
  }
  .info-result {
    > p {
      color: ${props => `${props.theme.palette.info.main}`};
    }
  }
  .result-item-icon-description {
    display: flex;
    align-items: center;
    > svg {
      margin-right: 1rem;
    }
  }
`;